import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueLazyLoad from 'vue-lazyload'
// import * as Sentry from '@sentry/browser'
// import * as Integrations from '@sentry/integrations'
import store from './store'
import './filter'
import './directives'
// import App from './App.vue'
import HComp from './components/index'
import '@js/logger'

const isProd = process.env.NODE_ENV === 'production'
Vue.prototype.$host = process.env.VUE_APP_BASE_URL
Vue.prototype.$rHost = process.env.VUE_APP_OSS_URL

if (/^http:\/\/heroes3\.top/.test(location.href)) {
  location.href = location.href.replace(/^http:\/\//, 'https://')
}

store.dispatch('device/initUAResult')

if ('serviceWorker' in navigator) {
  let swPath = 'sw.js'
  // if (isProd) {
  //   const version = process.env.PACKAGE_VERSION
  //   swPath = `ver/${version}/sw.js`
  // }

  navigator.serviceWorker.register(swPath)
    .then(function (reg) {
      // registration worked
    })
    .catch(function (error) {
      // registration failed
    })
}

if (isProd) {
  // Sentry.init({
  //   dsn: 'https://e70c1d0ee4f74053b0714c0842b22c13@sentry.io/1854595',
  //   integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  // })
  // const Loader = require('@js/combat/utils/loader')
  // Loader.load()
}

const router = new VueRouter({ routes: require('./router').default })

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || 'heroes'
  if (to.meta.requireAuth && !store.getters.isLogged) {
    try {
      await store.dispatch('user/checkUserInfo')
      next()
    } catch (err) {
      router.replace('/login')
    }
    return
  }
  next()
})

Vue.use(Vuex)
Vue.use(VueRouter)
Vue.use(VueLazyLoad, {
  preLoad: 1.05,
  attempt: 1
})
Vue.use(HComp)

Vue.config.devtools = true
Vue.config.productionTip = false

const vm = new Vue({
  router,
  el: '#app',
  store,
  template: '<router-view></router-view>'
})

if (isProd) {
  window.onbeforeunload = function () {
    if (/^\/combat/.test(vm.$route.path)) {
      return '当前操作即将导致丢失此次战役'
    }
    if (/^\/world/.test(vm.$route.path)) {
      if (localStorage.getItem('h3_ignore_reload') === '1') {
        localStorage.setItem('h3_ignore_reload', '0')
        return
      }
      return '请确认操作'
    }
  }
}

window.addEventListener('orientationchange', function () {
  location.reload()
})
console.log('>>> env', process.env);
